import {AmsListItemBase} from './AmsListItemBase';
import * as XCol from '../../framework.core/XExportColumn';

export class AmsHistoryListItem extends AmsListItemBase {
    userID: string = '';
    amsMessage: string = '';
    date: string | null = null;
    toDate: string | null = null;
    fromDate: string | null = null;
    description: string = '';
    hblNo: string = '';
    mblNo: string = '';
    sName: string = '';
    cName: string = '';
    nName: string = '';
    voyage: string = '';
    eta: string | null = null;
    fromEta: string | null = null;
    toEta: string | null = null;
    dCode: string = '';
    conVName: string = '';
    moveType: string = '';
    id: number = 0;

    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: '', width: 30, dataIndex: 'status', hiddenInColumnSetup: true}),
        XCol.Create({ col: 1, text: 'User', width: 100, dataIndex: 'userID', defaultColumnFocus : true}),
        XCol.Create({ col: 2, text: 'DP', width: 60, dataIndex: 'amsMessage', align: XCol.XAlignType.Center}),
        XCol.Create({ col: 3, text: 'Date', width: 75, dataIndex: 'date', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 4, text: 'DP Description', width: 200, dataIndex: 'description'}),
        XCol.Create({ col: 5, text: 'HBL #', width: 100, dataIndex: 'hblNo'}),
        XCol.Create({ col: 6, text: 'MBL #', width: 100, dataIndex: 'mblNo'}),
        XCol.Create({ col: 7, text: 'Shipper', width: 120, dataIndex: 'sName'}),
        XCol.Create({ col: 8, text: 'Consignee', width: 120, dataIndex: 'cName'}),
        XCol.Create({ col: 9, text: 'Notify', width: 120, dataIndex: 'nName'}),
        XCol.Create({ col: 10, text: 'Voyage #', width: 80, dataIndex: 'voyage'}),
        XCol.Create({ col: 11, text: 'ETA', width: 75, dataIndex: 'eta', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 12, text: 'Discharge', width: 80, dataIndex: 'dCode'}),
        XCol.Create({ col: 13, text: 'Vessel Name', width: 120, dataIndex: 'conVName'}),
        XCol.Create({ col: 14, text: 'Move Type', width: 80, dataIndex: 'moveType', noNullOrEmptySearch: true})
        ];


    public static getExportCollection(): XCol.XExportColumn[] {
        return this.ExportCollection;
    };
	
    public static OrderBy = { orderBy: AmsHistoryListItem.prototype.id, orderByAscending: false };

    public static formatData(data: AmsHistoryListItem[]) {
        return data.map((d: AmsHistoryListItem) => ({
          ...d,
        }));
    }
    public static MapSearchFields: {[key: string]: {[key: string]: string}} = {
        date: {from: 'fromDate', to: 'toDate'},
        eta: {from: 'fromEta', to: 'toEta'},
    }
}
